export const SET_WORKSTATION_STEP = "SET_WORKSTATION_STEP";
export const SCAN_INITIATED = "SCAN_INITIATED";
export const SCAN_SUCCESS = "SCAN_SUCCESS";
export const SCAN_FAILED = "SCAN_FAILED";
export const SCAN_REPORT_READY = "SCAN_REPORT_READY";

